// extracted by mini-css-extract-plugin
export default {"cls1":"qsd4BYnonljcPTWPjBqy","cls2":"xH1HlP4ncSZX6xJdAsL9 qsd4BYnonljcPTWPjBqy"};